/**
 * WARNING:
 * This file is auto-generated by apiCodeGen and will overwrite this function on every run.
 * Make sure this file's changes are reverted after running apiCodeGen or else the app WILL break.
 */
export function deepMerge<T, U extends T>(target: T, source: U): U {
  if (Array.isArray(source)) return [...source] as U;
  if (typeof source !== 'object' || source === null) return source;

  const result = { ...(target || {}) } as U;

  (Object.keys(source) as (keyof U)[]).forEach((key) => {
    const sourceVal = source[key];
    const targetVal = (target as U)[key];

    if (
      [sourceVal, targetVal].every((val) => val && val instanceof Object && !Array.isArray(val))
    ) {
      result[key] = deepMerge(targetVal, sourceVal);
    } else {
      result[key] = sourceVal;
    }
  });

  return result;
}
